import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import FormControl from '@mui/material/FormControl';
import Stack from '@mui/material/Stack';
import Bs4Tooltip from '../Bs4Components/Bs4Tooltip';
import IconButton from '@mui/material/IconButton';
import Pagination from '@mui/material/Pagination';

import Bs4Kartoteka from '../Bs4Kartoteka'
import Bs4Form from '../Bs4Form/Bs4Form'
import Bs4MainDispatch from '../Bs4MainDispatch';
import Bs4MainWindow from '../Bs4MainWindow';
import Bs4HorizontalMenu, { MENU_TYPE_TOP } from '../Bs4Menu/Bs4HorizontalMenu'
import {EventEmit} from '../Bs4Components/Bs4Utils'
import { Box, Typography } from '@mui/material';
import { getUxTemplate, UXTEMPLATE } from '../Bs4Theme/Bs4UxTemplates';
import Bs4I18N from '../Bs4I18N';
import Bs4Pagination from '../Bs4Components/Bs4Pagination'

export default class Bs4ReportGeneric {
  static ROW_EDITED = 'row_edited';
  static COLUMN_DATA = 'data_';
  static COLUMN_MENU = 'menu_';
  static BS4_PAGE_PROPS_CHANGE = 'Bs4PagePropsChange';
  static MINI_LEFT_MENU = 'miniLeftMenu';

  constructor(props) {
    this.props = props;
    this.bs4KartotekaId = props.bs4KartotekaId;
    this.optionId = props.optionId;
    this.formId = props.formId;
    this.eventEmit = new EventEmit();
  }

  setMiniLeftMenu = () => {
    Bs4MainWindow.instance.setMiniLeftMenu(Boolean(this.getPageParam(Bs4Form.MINI_LEFT_MENU)));
  }

  getDebugInfo = () => {
    return this.bs4KartotekaId+', '+this.optionId+', '+(this.formId || '?')
  }

  isSimple = () => false;

  editedRows = new Map();

  getEditedRows() {
    return Array.from(this.editedRows.values());
  }

  rowEdited(id, row) {
    this.editedRows.set(id, row); /// ??? {...row}
    this.trigger(Bs4ReportGeneric.ROW_EDITED, id, row);
  }

  changesSaved() {
    console.log('...changesSaved...grid...')
    this.clear();
  }

  setBs4PageProps = (bs4PageProps) => {
    this.bs4PageProps = bs4PageProps;
    this.trigger(Bs4ReportGeneric.BS4_PAGE_PROPS_CHANGE, bs4PageProps);
  }
  
  bs4HandleChangePage(page) {
    console.log('== Error === Bs4GenericReport == handleChangePage - not implemented', page)
  }

  bs4bs4ViewProps = {};

  on(name, onFunction) {
    this.eventEmit.on(name, onFunction);  
  }

  off(onFunction) {
    this.eventEmit.off(onFunction);  
  }

  trigger(name, ...params) {
    this.eventEmit?.trigger(name, ...params)    
  }

  createModel() {
    this.criteriaFields = 0;
    const bs4Kartoteka = Bs4Kartoteka.get(this.bs4KartotekaId);
    const bs4Option = bs4Kartoteka.getBs4Option(this.optionId);
    bs4Option.bs4Form = new Bs4Form({...this.props}, true);
    bs4Option.bs4Form.createModel();
    this.criteriaFields = bs4Option.bs4Form.getFields().length;
    if (!bs4Option) {
      console.log('=== Error === initCriteria ===',this.props, bs4Kartoteka)
    }
    
    this.setUxTemplate()

    const limitRows = parseInt(this.props.limitRows);
    this.bs4PageProps = {
      counter: 0,
      paglim: parseInt(limitRows || Bs4Kartoteka.get(this.bs4KartotekaId)?.message?._Komunikat?.pageParams[this.optionId]?.paglim) || 50,
      currentPage: 0,
      lastRow: 0,
      lastPage: 0,
      inProgress: true,
    }    
  }

  bs4KartotekaId = null;
  optionId = null;

  getPageParam(param) {
    return Bs4Kartoteka.get(this.bs4KartotekaId)?.getPageParam(this.optionId, param);
	}

  defaultUxTemplate = {
    class: 189,
    name: 'Bs4ReportGeneric',
    body: {
      Report: {          
      },
    },
  };

  setUxTemplate = (id) => {
    if (!id) id = this.getPageParam(UXTEMPLATE);
    this.uxTemplate = getUxTemplate(this.defaultUxTemplate, this.props.optionType, id, this.optionId,);
  }

  getUxTemplateEditor = (uxEditor) => {
    return []
  }

  getColDef() {   
    return Bs4Kartoteka.get(this.bs4KartotekaId)?.message?._Komunikat?.col_def[this.optionId] ||  [];
  }  

  getData() {
    console.log('== Error === Bs4GenericReport == getData - not implemented')
    return []
  }

  getSelectedIdArray() {
    console.log('== Error === Bs4GenericReport == getSelectedIdArray - not implemented')
    return []
  }

  clearAllCriteria() {
    const bs4Kartoteka = Bs4Kartoteka.get(this.bs4KartotekaId);
    const bs4Option = bs4Kartoteka.getBs4Option(this.optionId);
    bs4Option.bs4Form.clear();
  }

  defaultCriteriaVals() {
    const bs4Kartoteka = Bs4Kartoteka.get(this.bs4KartotekaId);
    if (!bs4Kartoteka) {
      console.log('...ERROR !!! defaultCriteriaVals, !bs4Kartotek')
      return {error: '!bs4Kartotek'}
    }
    const bs4Option = bs4Kartoteka.getBs4Option(this.optionId);
    return {
      currCardViewId: this.bs4KartotekaId,
      optionId: this.optionId,
      currFormId: this.formId,
      parametrJs: JSON.stringify(bs4Option.bs4Form.gatherCriteriaValues()),
    }
  }

  packColumnLayout() {    
    console.log('== Error === Bs4GenericReport == packColumnLayout - not implemented')
    return null;
  }

  gridSortToHidden() {    
    return null;
  }

  atrybProgressbar = (item) => {
    if (!item.ATRYB_PROGRESSBAR) return;
    const bs4Kartoteka = Bs4Kartoteka.get(this.bs4KartotekaId);    
    bs4Kartoteka.atrybProgressbar({
      menuItem: item,
    });
  }

  // polecenie wykonywane po kliknieciu na pozycje w menu na stronie typu zestawienie
	runListOption(item) {
		const details = { 
			reportOptionId: item?.bs4Id,
			selectedRows: this.getSelectedIdArray(),
			storeData: this.getData(),
      ukladKryt: JSON.stringify(this.fetchCriteriaVals()),
			ukladKolumn: this.packColumnLayout(),
			ukladSort: JSON.stringify(this.gridSortToHidden()),      
      currFormId: this.formId,
		}

		Bs4MainDispatch.commandParser('Bs4ReportOption', details, this.bs4KartotekaId);
    this.atrybProgressbar(item);
	}

  wykonac = Bs4I18N.getTT('Wykonać', 'Wykonać', this.constructor.name);
  
  handleMenuClick = (item) => {
    if (parseInt(item.checkBs4Dirty) === 1) this.handleCheckBs4Dirty(() => this.runListOption(item), this.wykonac+' "'+item.text+'" ?');
    else this.runListOption(item);
  }

  reload = () => {
    console.log('=== Error === reload not implemented');
  }

  /////////////////// form field /////////////////////////////
  getValue() {
    console.log('== Error === Bs4GenericReport == getValue - not implemented')
    return null;
  }

  resetOriginalValue() {
    console.log('== Error === Bs4GenericReport == resetOriginalValue - not implemented')
  }  

  isDifferentValues (oldValue, newVaue) {
    console.log('== Error === Bs4GenericReport == isDifferentValues - not implemented', oldValue, newVaue)
    return false;
  }

  clear() {
    this.editedRows.clear();
    this.trigger(Bs4ReportGeneric.ROW_EDITED, null);
  }

  isDirty() {
    const editedRows = this.getEditedRows();
    if (Array.isArray(editedRows) && editedRows.length > 0) return true;
    return false;
  }
  //////////////////////////////////////////////////////////

  handleCheckBs4Dirty(callBack, text) {
    if (this.isDirty()) {
      const bs4kartoteka = Bs4Kartoteka.get(this.bs4KartotekaId);
      bs4kartoteka.canClose(text)
      .then(msg => {
        this.clear();
        callBack();
      })
      .catch(msg => {
        console.log(msg)
      })
    } else {
      callBack()
    }
  }

  setColumnsMenu() {    
    let columnsMenu = [];
    let menuItems = Bs4Kartoteka.get(this.props.bs4KartotekaId).getReportMenu(this.props.optionId);    
    menuItems = JSON.parse(JSON.stringify(menuItems));
    menuItems = Object.values(menuItems).filter(item => {
      if (item.items) item.items = item.items.filter(item => {
        if (item.selectRows) {
          columnsMenu.push(item);
          return false;
        }
        return true;
      })

      if (item.selectRows) {
        columnsMenu.push(item);
        return false;
      }
      return true;
    });

    this.menuItems = menuItems.filter(item => {
      if (item.items?.length === 0) return false;
      return true;
    }) 

    this.columnsMenu = columnsMenu.map(item => {
      return {
        index: String(Bs4ReportGeneric.COLUMN_MENU+item.bs4Id), 
        id: item.bs4Id, 
        title: item.text, 
        text: item.bs4tip, 
        style: item.bs4CustomCss, 
        menuItem: item,
        items: [],        
      };
    })

    console.log('...View...MENU...', this.menuItems, this.columnsMenu);
  }
  
  reportOptionMenu = null;
  setReportOptionMenu = (menu) => this.reportOptionMenu = menu;

  ViewIcon = (props) => {
    const report = this;

    const handleShow = () => {
      this.remembersettings = false;
      this.reload();
    }

    const handleRemember = () => {
      this.remembersettings = true;
      this.reload();
    }

    const handleReset = () => {
      this.remembersettings = false;
      Bs4MainDispatch.commandParser('Bs4PrefsReset', {js_ForgetOptionId: this.optionId, currFormId: this.formId}, this.bs4KartotekaId);      
      this.clearAllCriteria();
      this.reload();
    }

    return (
      <Stack {...props} direction="row" justifyContent="flex-start" alignItems="center">
        <Bs4Tooltip title={'Pokaż'} arrow describeChild>
          <IconButton onClick={handleShow}><i className="fa-regular fa-arrows-rotate" style={{fontSize: '0.875rem'}}></i></IconButton>
        </Bs4Tooltip>
        <Bs4Tooltip title={'Pamiętaj'} arrow describeChild>
          <IconButton onClick={handleRemember}><i className="fa-regular fa-thumbtack" style={{fontSize: '0.875rem'}}></i></IconButton>
        </Bs4Tooltip>
        <Bs4Tooltip title={'Resetuj'} arrow describeChild>
          <IconButton onClick={handleReset}><i className="fa-regular fa-eraser" style={{fontSize: '0.875rem'}}></i></IconButton>
        </Bs4Tooltip>
      </Stack>        
    )
  }


  ViewRowsShown = (props) => {
    const toRow   = Math.min(this.bs4PageProps.lastRow, (this.bs4PageProps.currentPage + 1) * this.bs4PageProps.paglim);
    const ofRows  = this.bs4PageProps.lastRow;
    const counter = this.bs4PageProps.counter;
    const fromRow = Math.min(this.bs4PageProps.currentPage * this.bs4PageProps.paglim + 1, toRow);
    const [displayed, noDataToDisplay, pleaseWait] = Bs4I18N.useTTA([
      ["%s - %s of %s displayed", 'Wyświetlono %s - %s z %s', this.constructor.name],
      ["No data to display", 'Brak danych do wyświetlenia', this.constructor.name],
      ["Please wait...", 'Proszę czekać...', this.constructor.name],
    ]);

    const text = React.useMemo(() => {
      let text = displayed;
      text = text.replace('%s', fromRow);
      text = text.replace('%s', toRow);
      text = text.replace('%s', ofRows);
      if (props.smallScreen) text = '';
      if (this.bs4PageProps.inProgress) return pleaseWait;
      return ofRows ? text : noDataToDisplay;
    }, [fromRow, toRow, ofRows, props.smallScreen, counter, this.bs4PageProps.inProgress]);

    if (this.isSimple() && ofRows) return null;    

    return <Typography variant='body2'>{text}</Typography>   
  }

  ViewBs4Footer = React.forwardRef((props, ref) => {
    const report = this;
    //const theme = useTheme();    
    
    const [bs4PageProps, setBs4PageProps] = React.useState(this.bs4PageProps);

    React.useEffect(() => {            
      this.on(Bs4ReportGeneric.BS4_PAGE_PROPS_CHANGE, (bs4PageProps) => {
        //console.log('...fetchMore...BS4_PAGE_PROPS_CHANGE...', bs4PageProps)
        setBs4PageProps(bs4PageProps);
      })
    }, [])

    if (this.isSimple()) return <report.ViewRowsShown/>;    

    const ViewPagination = props.smallScreen ? Bs4Pagination : Pagination;

    return (
      <Stack 
        ref={ref}
        direction="row" 
        justifyContent="space-between" 
        alignItems="center" 
        spacing={1} 
        p={1}
      >
        <ViewPagination 
          count={bs4PageProps.lastPage} 
          page={bs4PageProps.currentPage + 1} 
          onChange={(event, page) => this.bs4HandleChangePage(page)}
          hidePrevButton 
          hideNextButton
          //siblingCount={0}
          //boundaryCount={2}
          //variant='outlined'
        />
        <report.ViewRowsShown smallScreen={props.smallScreen}/>
        <report.ViewIcon flex={0}/>
      </Stack>
    )
  });

  ReportBs4HorizontalMenu = (props) => {
    const report = this;
    const menuItems = React.useMemo(() => {
      return props.bs4Menu || Bs4Kartoteka.get(this.bs4KartotekaId).getReportMenu(this.optionId)
    }, [props.bs4Menu]);    

    const debugText = Bs4MainDispatch.speedBs4KarOpt(this.props.bs4KartotekaId, this.props.optionId)+' '+this.props.optionType+' '+this.props.formId+' l:'+menuItems?.length;

    Bs4MainDispatch.speedRun((tag) => {
      console.log(Bs4MainDispatch.speedNextTime(tag), debugText)
    }, 'MenuH.Report');

    return (
      <Bs4HorizontalMenu
        bs4MenuType={MENU_TYPE_TOP}
        onMenuClick={report.handleMenuClick} 
        bs4Menu={menuItems}
        setMenu={report.setReportOptionMenu}
        variantMenuIcon='popper'
        variantMenuName=''
        {...report.props}         
        debugText={debugText}
      />
    );
  }

  ViewComponent = React.forwardRef((props, ref) => {
    const theme = useTheme();
    return (
      <FormControl fullWidth>
        <Typography sx={{color: theme.palette.error.main}}>{'Nie można wyświetlić elementu. Proszę sprawdzić konfigurację.'}</Typography>
      </FormControl>      
    )
  });
}
